module.exports = __webpack_public_path__ + "img/yszc-sj.db9fc342.png";